import { render, staticRenderFns } from "./App.pug?vue&type=template&id=0039ddbb&lang=pug&"
import script from "./App.js?vue&type=script&lang=js&"
export * from "./App.js?vue&type=script&lang=js&"
import style0 from "../scss/App.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0039ddbb')) {
      api.createRecord('0039ddbb', component.options)
    } else {
      api.reload('0039ddbb', component.options)
    }
    module.hot.accept("./App.pug?vue&type=template&id=0039ddbb&lang=pug&", function () {
      api.rerender('0039ddbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/App/index.vue"
export default component.exports